import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface BillingTenantContract {
  currency: string | null;
  recurringAmount: string | null;
  recurringFrequency: string | null;
  txFeeRate: string | null;
}

export interface BillingTenantDefaultFee {
  calculationMethod: string | null;
  feeRate: string | null;
  flatFeeAmount: string | null;
  refundPolicy: string | null;
}

export interface BillingTenantRow {
  id: string;
  name: string;
  domain: string | null;
  revenueModel: string | null;
  status: string | null;
  hasActiveContract: boolean;
  hasDefaultPolicy: boolean;
  contract: BillingTenantContract | null;
  defaultFee: BillingTenantDefaultFee | null;
}

export interface BillingTenantListResult {
  rows: BillingTenantRow[];
  total: number;
  page: number;
  limit: number;
}

export interface ListBillingTenantsParams {
  search?: string;
  revenueModel?: string;
  status?: string;
  page?: number;
  limit?: number;
}

// Server-side aggregate tenant list (UI-SPEC §2.1) — search/filters/pagination
// resolve on the backend. Distinct from the theme TenantApi (theme management).
export const listBillingTenants = (
  params?: ListBillingTenantsParams
// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<BillingTenantListResult> => httpRequest.get("/bil/admin/tenants", params as any);